// SidebarContext.js

import React, { createContext, useState, useContext } from "react";

// Create a context for managing sidebar toggle state
const SidebarContext = createContext();

// Custom hook to consume the sidebar context
export const useSidebar = () => useContext(SidebarContext);

// Sidebar provider component
export const SidebarProvider = ({ children }) => {
  // State to manage the visibility of the sidebar
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(false);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Function to toggle sidebar visibility
  const toggleRightSidebar = () => {
    setIsRightSidebarOpen(!isRightSidebarOpen);
  };

  return <SidebarContext.Provider value={{ isSidebarOpen, toggleSidebar, toggleRightSidebar, isRightSidebarOpen, setIsSidebarOpen }}>{children}</SidebarContext.Provider>;
};
